// Simple localStorage cache with TTL (ms)
// Keys are namespaced to avoid collisions across environments

const NAMESPACE = "weez-cache:";

function now() {
	return Date.now();
}

export function setCacheItem(key, value, ttlMs) {
	try {
		const record = {
			v: value,
			expiresAt: ttlMs ? now() + ttlMs : null,
		};
		localStorage.setItem(NAMESPACE + key, JSON.stringify(record));
	} catch (_) {
		// Swallow write errors (quota/SSR)
	}
}

export function getCacheItem(key) {
	try {
		const raw = localStorage.getItem(NAMESPACE + key);
		if (!raw) return null;
		const record = JSON.parse(raw);
		if (record && record.expiresAt && now() > record.expiresAt) {
			localStorage.removeItem(NAMESPACE + key);
			return null;
		}
		return record ? record.v : null;
	} catch (_) {
		return null;
	}
}

export function removeCacheItem(key) {
	try {
		localStorage.removeItem(NAMESPACE + key);
	} catch (_) {}
}

export const ONE_HOUR = 60 * 60 * 1000;
export const ONE_DAY = 24 * ONE_HOUR;


